<template>
  <div v-if="type" :class="clazz">
    <img v-if="type === 'H'" src="@/assets/images/hot.png" style="margin-right: 2px" width="12px" height="12px" />
    {{ types[this.type] }}
  </div>
</template>

<script>
const types = {
  R: "Recommand",
  H: "Hot"
};

export default {
  props: {
    type: String
  },
  data() {
    return {
      types
    };
  },
  computed: {
    clazz() {
      return ["label-box", types[this.type] || ""];
    }
  }
};
</script>

<style lang="scss" scoped>
.label-box {
  font-size: $fs-xxs;
  color: white;
  font-weight: 500;
  padding: 4px 8px;
  background: linear-gradient(135deg, #547fff, #7ed1ff);
  border-radius: 6px 0px 6px 0px;
}
.Hot {
  background: linear-gradient(135deg, #ff3ab7, #ff217b);
  border: 1px solid #ff217b;
  display: flex;
}
</style>
